import { toMonetaryString } from '../utils/utilsMonetary';

const utilsMixins = {
  methods: {
    utilsToMonetaryString: toMonetaryString,
  },
}

export default utilsMixins;
